import React, { Component } from "react";
import { connect } from "react-redux";
import LoadingCube from "sub_components/Common/LoadingCube";
import CalendarDay from "blox_components/Billing/TotalAmountDue/Components/CalendarDay";
import CallToAction from "blox_components/Billing/TotalAmountDue/Components/CallToAction";
import { BillingApi } from "services/billing";
import { Permissions } from "services/permissions";

class TotalAmountDue extends Component {
  constructor(props) {
    super(props);
    this.state = {
      summary: null,
      invoiceErr: null,
      summaryErr: null,
    };
  }

  getSummary = async () => {
    const { company_info: { customer: { id }, intacctId = 0 } = {} } =
      this.props;
    try {
      const response = await new BillingApi().getSummary(id, intacctId);
      if (response) {
        const {
          balance,
          error,
          nextBillingDate,
          amountOverdue,
          amountDueToday,
        } = response.data;

        this.setState({
          summary: {
            balance,
            error,
            nextBillingDate,
            amountOverdue,
            amountDueToday,
          },
        });
      } else {
        this.setState({
          summary: {},
        });
      }
    } catch (e) {
      this.setState({ summaryErr: e.message, summary: {} });
    }
  };

  goToMakeAPayment = () => {
    const { navigate } = this.props;

    navigate("/portal/billing/make_a_payment");
  };

  componentDidMount() {
    this.getSummary();
  }

  render() {
    const { pages, invoices, invoicesLoaded } = this.props;
    const { summary } = this.state;

    const hasOnlinePaymentAccess = Permissions.checkComponentAccess(
      pages,
      "Overview",
      "paynow-component"
    );
    const loading = summary && !invoicesLoaded ? false : true;

    return (
      <>
        {loading && <LoadingCube />}
        {!loading && (
          <div class="total-amount-due">
            <CalendarDay invoices={invoices} summary={summary} />
            <CallToAction
              invoices={invoices}
              summary={summary}
              hasOnlinePaymentAccess={hasOnlinePaymentAccess}
              goToMakeAPayment={this.goToMakeAPayment}
            />
          </div>
        )}
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth_status: state.auth_status,
    company_info: state.company_info,
  };
}

export default connect(mapStateToProps)(TotalAmountDue);
